module.exports = __webpack_public_path__ + "media/assets/link-4a437686835fbceeb9cf2acc519af3d917a014047ee658a71b700a1e08636fbe.svg";